// ** MUI Imports
import Card from '@mui/material/Card'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'

// ** Third Party Imports
import { ApexOptions } from 'apexcharts'
import ReactApexcharts from 'react-apexcharts';
import Tooltip from '@mui/material/Tooltip'
import { useEffect, useState } from 'react'

interface Props {
    subHeading: string,
    seriesValue: number,
    toolTip: string,
}

const RadialBarChartDashboard = ({ subHeading, seriesValue, toolTip }: Props) => {
    // ** Hook
    const theme = useTheme()
    const [labelColor, setlabelColor] = useState<string>('lightgrey')
    const [lineColor, setLineColor] = useState<string>('#008000')

    useEffect(() => {
        switch (true) {
            case (seriesValue == 100):
                setlabelColor('orange');
                setLineColor('#ffa500');
                break;
            case (seriesValue  > 100):
                setlabelColor('green');
                setLineColor('#008000');
                break;
            case (seriesValue < 100):
                setlabelColor('red');
                setLineColor('#FF0000');
                break;
            default:
            // code block
        }
    }, [seriesValue])
    

    const options: ApexOptions = {
        chart: {
            sparkline: { enabled: true },
            
        },
        stroke: { lineCap: 'round' },
        //colors: [theme.palette.primary.dark],
        colors: [lineColor],
        plotOptions: {
            radialBar: {
                endAngle: 90,
                startAngle: -90,
                hollow: { size: '65%' },
                dataLabels: {
                    name: { show: false },
                    value: {
                        offsetY: 0,
                        color: labelColor
                    }
                }
            }
        }
    }

    return (
        <Card>
            <CardContent sx={{ '& .apexcharts-datalabel-value': { fontSize: '1.25rem', fontWeight: '500 !important' } }}>
                <ReactApexcharts type='radialBar' height={103} options={options} series={[seriesValue]}  />
                <Tooltip title={toolTip} >
                    <Typography variant='body2' sx={{ textAlign: 'center', color: labelColor }}>
                        {subHeading}
                    </Typography>
                </Tooltip>    
            </CardContent>
        </Card>
    )
}

export default RadialBarChartDashboard